import { render, staticRenderFns } from "./SearchOnOtherSiteDropdown.vue?vue&type=template&id=049da8ae"
import script from "./SearchOnOtherSiteDropdown.vue?vue&type=script&lang=js"
export * from "./SearchOnOtherSiteDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports